<template>
<span>
    <v-dialog v-model="status.boxAlert" persistent max-width="900px">
        <template v-slot:activator="{ on }">
            <v-btn color="primary" class="text-capitalize" dark @click="loginRegister" v-on="on">Login / Register</v-btn>
        </template>
        <v-card>
            <v-icon class="close-btn" @click="status.boxAlert = false">mdi-close</v-icon>
            <v-row>
                <v-col cols="5" class="d-none d-sm-block" style="background: #eff2f7">
                    <v-card-text>
                        <v-img src="https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/demo-1/img/login.d814adb7.png" aspect-ratio="1" contain></v-img>
                    </v-card-text>
                </v-col>
                <v-col cols="12" sm="7" md="7" class="pa-6 pb-0">
                    <v-card-text v-if="isReset" class="py-0">
                        <div class="grey--text text--darken-1" v-show="show">
                            <p class="headline" value="tab-1">Login</p>
                            <p class="body-2">Welcome back, please login to your account.</p>
                        </div>
                        <div class="grey--text text--darken-1" v-show="!show">
                            <p class="headline" value="tab-1">Register</p>
                            <p class="body-2">Welcome back, please login to your account.</p>
                        </div>
                        <v-alert v-if="Alert.active" v-model="Alert.active" text dismissible prominent :type="Alert.action" class="mt-3" icon="mdi-cloud-alert">
                            {{ Alert.message }}
                        </v-alert>
                        <v-tabs v-model="model" slider-color="yellow" background-color="transparent">
                            <v-tab href="#tab-1" class="text-capitalize" @click="tab1">
                                Login
                            </v-tab>
                            <v-tab href="#tab-2" class="text-capitalize" @click="tab2">
                                Register
                            </v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="model">

                            <!-- Login form -->

                            <v-tab-item value="tab-1">
                                <Login @forget="isReset = false" />
                            </v-tab-item>

                            <!-- Register  form-->

                            <v-tab-item value="tab-2">
                                <Register />
                            </v-tab-item>
                        </v-tabs-items>

                    </v-card-text>
                    <v-card-text v-if="!isReset" class="py-0">
                        <Forget @reset="isReset = true" />
                    </v-card-text>
                </v-col>
            </v-row>

        </v-card>
    </v-dialog>
</span>
</template>

<script>
import {
    mapGetters
} from 'vuex'
export default {
    components: {
        Register: () => import('./Register'),
        Login: () => import('./Login'),
        Forget: () => import('./Forget-password')
        
    },
    data: () => ({
        show: true,
        model: 'tab-2',
        text: '',
        snackbar: false,
        dialog: false,
        isReset: true
    }),
    computed: {
        ...mapGetters(['status', 'Alert']),
    },
    methods:{
        tab1(){
            this.show = true
            this.Alert.active = false
        },
        tab2(){
            this.show = false
            this.Alert.active = false
        },
        loginRegister(){
            this.isReset = true
        }
    }

}
</script>
